/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo } from 'react';

import { ExpandMore } from '@material-ui/icons';

import { object } from 'prop-types';
import { generate } from 'shortid';

import { ExpansionPanelStyled, ExpansionPanelSummaryStyled, ExpansionPanelDetailsStyled, Link } from './styles';

const HeaderDrawerSubCategory = ({ subCategory }) => (
  <ExpansionPanelStyled elevation={0}>
    <ExpansionPanelSummaryStyled expandIcon={<ExpandMore />}>{subCategory.title}</ExpansionPanelSummaryStyled>
    <ExpansionPanelDetailsStyled>
      <Link
        onClick={() => {
          // eslint-disable-next-line no-restricted-globals
          location.href = subCategory.link;
        }}
        title={subCategory.title}
        aria-label={subCategory.title}
      >
        Ver tudo em {subCategory.title}
      </Link>
      {subCategory.children &&
        subCategory.children.map((item) => (
          <Link padding="5px 16px" key={generate()} href={item.link} title={item.title} item>
            {item.title}
          </Link>
        ))}
    </ExpansionPanelDetailsStyled>
  </ExpansionPanelStyled>
);

HeaderDrawerSubCategory.propTypes = {
  subCategory: object,
};

export default memo(HeaderDrawerSubCategory);
